import { Component, Input } from '@angular/core';

@Component({
  selector: 'oh-image-preloader',
  templateUrl: './image-preloader.component.html',
})
export class ImagePreloaderComponent {
  @Input() images: any;

  constructor() {}
}
